module.exports = __webpack_public_path__ + "img/19.c3c476a4.svg";